<template>
  <NodePressRelease v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'PagePressReleaseSlug',
})

definePageMeta({
  name: 'press-release-detail',
  path: '/medien/:slug(.*)*',
  languageMapping: {
    fr: '/communiques-de-presse/:slug(.*)*',
    en: '/press-release/:slug(.*)*',
  },
})

const { entity: node } = await useDrupalRouteQuery('nodePressRelease')

await renderPageDependencies()
</script>
